import { render, staticRenderFns } from "./v-editor.vue?vue&type=template&id=52649fdc&scoped=true&"
import script from "./v-editor.vue?vue&type=script&lang=js&"
export * from "./v-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52649fdc",
  null
  
)

export default component.exports